import axios from "axios";
import { getApiUrl, getDomainId } from "../../config/tenant";

const config = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
    }
};

const fetchExperiences = () => {
    return axios.get(`${getApiUrl()}/experiences?Domain=${getDomainId()}`, config);
}

const fetchExperiencesPage = ({ page, pageSize }) => {
    return axios.get(`${getApiUrl()}/experiences?Domain=${getDomainId()}&page=${page}&pageSize=${pageSize}`, config);
}

const fetchExperienceById = ({ id }) => {
    return axios.get(`${getApiUrl()}/experiences/${id}?Domain=${getDomainId()}`, config);
}

const createExperience = ({ name }) => {
    return axios.post(`${getApiUrl()}/experiences`, { name }, config);
}

const updateExperience = ({ id, experience }) => {
    return axios.put(`${getApiUrl()}/experiences/${id}`, experience, config);
}

const uploadImage = ({ formData, }) => {
    return axios.post(`${getApiUrl()}/images`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        ...config
    });
}

const updateExperienceImage = ({ id, image }) => {
    return axios.put(`${getApiUrl()}/experiences/${id}/image`, { image }, config);
}

const deleteExperience = ({ id }) => {
    return axios.delete(`${getApiUrl()}/experiences/${id}`, config);
}

const fetchEventsByExperienceId = ({ id }) => {
    return axios.get(`${getApiUrl()}/experiences/${id}/events`, config);
}

const createEvents  = ({ experienceId, dates }) => {
    return axios.post(`${getApiUrl()}/events`, {experienceId, dates}, config);
}

const fetchAllEvents = () => {
    return axios.get(`${getApiUrl()}/events`, config);
}

const fetchEventsPage = ({ scope, page, pageSize }) => {
    return axios.get(`${getApiUrl()}/events?scope=${scope}&page=${page}&pageSize=${pageSize}`, config);
}

const fetchEventById = ({ id }) => {
    return axios.get(`${getApiUrl()}/events/${id}`, config);
}

const updateEvent = ({ id, event }) => {
    return axios.put(`${getApiUrl()}/events/${id}`, event, config);
}

const deleteEvent = ({ id }) => {
    return axios.delete(`${getApiUrl()}/events/${id}`, config);
}

const updateSiteSettings = ({ name, heading, subHeading, backgroundImage, primaryColor, logo, favicon, contactPhone, contactEmail, autoAcceptBooking, walletEnabled, walletLowBalanceThreshold, walletLowBalanceRemindersEnabled, terms, termsDocumentName, termsAcceptanceMethod, paymentProcessor, worldpayTestMode, worldpayEntity, worldpayUsername, worldpayPassword, stripeTestMode, stripeSecretKey, stripeEndpointSecret, sumupTestMode, sumupClientId, sumupClientSecret, sumupMerchantId, sumupPayToEmail, googlePayEnabled, googlePayMerchantId, applePayDomainAssociation, metaPixelEnabled, metaPixelId, metaConversionsAccessToken, metaTestEventCode, metaCurrency, notifyAdminOnExperienceBooking, healthScreeningEnabled, remoteLockClientId, remoteLockSecret }) => {
    return axios.put(`${getApiUrl()}/domains`, {
        name,
        heading,
        subHeading,
        backgroundImage,
        primaryColor,
        logo,
        favicon,
        contactPhone,
        contactEmail,
        autoAcceptBooking,
        walletEnabled,
        walletLowBalanceThreshold,
        walletLowBalanceRemindersEnabled,
        terms,
        termsDocumentName,
        termsAcceptanceMethod,
        paymentProcessor,
        worldpayTestMode,
        worldpayEntity,
        worldpayUsername,
        worldpayPassword,
        stripeTestMode,
        stripeSecretKey,
        stripeEndpointSecret,
        sumupTestMode,
        sumupClientId,
        sumupClientSecret,
        sumupMerchantId,
        sumupPayToEmail,
        googlePayEnabled,
        googlePayMerchantId,
        applePayDomainAssociation,
        metaPixelEnabled,
        metaPixelId,
        metaConversionsAccessToken,
        metaTestEventCode,
        metaCurrency,
        notifyAdminOnExperienceBooking,
        healthScreeningEnabled,
        remoteLockClientId,
        remoteLockSecret
    }, config);
}

const fetchDomainAdmin = () => {
    return axios.get(`${getApiUrl()}/domains/admin`, config);
}

const testRemoteLockConnection = ({ remoteLockClientId, remoteLockSecret }) => {
    return axios.post(`${getApiUrl()}/domains/remote-lock/test-connection`, { remoteLockClientId, remoteLockSecret }, config);
}

const fetchEmailNotificationSettings = () => {
    return axios.get(`${getApiUrl()}/domains/email-notifications`, config);
}

const updateEmailNotificationSettings = (emailNotifications) => {
    return axios.put(`${getApiUrl()}/domains/email-notifications`, { emailNotifications }, config);
}

const createExperienceBooking = ({ eventId, tickets, notes, paymentMethod, discountCode, marketingConsent }) => {
    return axios.post(`${getApiUrl()}/experience-bookings`, { eventId, tickets, notes, paymentMethod, returnUrl: window.location.origin, discountCode, marketingConsent }, config);
}

const checkDiscountCode = (code) => {
    return axios.get(`${getApiUrl()}/discount-codes/code/${code}`, config);
}

const createBulkExperienceBookings = ({ bookings, paymentMethod, discountCode, marketingConsent }) => {
    return axios.post(`${getApiUrl()}/experience-bookings/bulk`, { bookings, paymentMethod, returnUrl: window.location.origin, discountCode, marketingConsent }, config);
}

// Bundles
const fetchBundlesForExperience = ({ experienceId }) => {
    return axios.get(`${getApiUrl()}/bundles/experience/${experienceId}?Domain=${getDomainId()}`, config);
}

const createBundlePurchase = ({ bundleId, tickets }) => {
    return axios.post(`${getApiUrl()}/bundles/purchase`, { bundleId, tickets }, config);
}

const createBundle = ({ name, events, price, overrideRefundWindow }) => {
    return axios.post(`${getApiUrl()}/bundles`, { name, events, price, overrideRefundWindow }, config);
}

const updateBundle = ({ id, bundle }) => {
    return axios.put(`${getApiUrl()}/bundles/${id}`, bundle, config);
}

const deleteBundle = ({ id }) => {
    return axios.delete(`${getApiUrl()}/bundles/${id}`, config);
}

const fetchBundleById = ({ id }) => {
    return axios.get(`${getApiUrl()}/bundles/${id}`, config);
}

const fetchAllExperienceBookings = () => {
    return axios.get(`${getApiUrl()}/experience-bookings`, config);
}

const fetchExperienceBookingsPage = ({ scope, page, pageSize }) => {
    return axios.get(`${getApiUrl()}/experience-bookings?scope=${scope}&page=${page}&pageSize=${pageSize}`, config);
}

const exportExperienceBookings = () => {
    return axios.get(`${getApiUrl()}/experience-bookings/export`, {
        ...config,
        responseType: 'blob'
    });
}

const fetchStuckExperienceBookingPayments = (olderThanHours = 24) => {
    return axios.get(`${getApiUrl()}/experience-bookings/stuck-payments?olderThanHours=${olderThanHours}`, config);
}

const importExperienceBookings = (file, onUploadProgress, onImportProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
    let downloadedLength = 0;
    let progressBuffer = '';

    return axios.post(`${getApiUrl()}/experience-bookings/import?stream=true`, formData, {
        ...config,
        responseType: 'text',
        headers: {
            ...config.headers,
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress,
        onDownloadProgress: (progressEvent) => {
            if(!onImportProgress) return;
            const responseText = progressEvent.currentTarget?.response || progressEvent.target?.responseText || '';
            const nextChunk = responseText.slice(downloadedLength);
            downloadedLength = responseText.length;
            progressBuffer += nextChunk;
            const lines = progressBuffer.split('\n');
            progressBuffer = lines.pop();
            lines.filter(Boolean).forEach((line) => {
                try {
                    onImportProgress(JSON.parse(line));
                } catch(err) {
                    console.error('Failed to parse booking import progress', err);
                }
            });
        }
    });
}

const fetchExperienceBooking = ({ id }) => {
    return axios.get(`${getApiUrl()}/experience-bookings/${id}`, config);
}

const fetchExperienceBookingsByEventId = ({ id }) => {
    return axios.get(`${getApiUrl()}/events/${id}/experience-bookings`, config);
}

const cancelExperienceBooking = ({ id, refund }) => {
    return axios.put(`${getApiUrl()}/experience-bookings/${id}/cancel`, { refund }, config);
}

const adminCreateExperienceBooking = ({ eventId, targetUserId, tickets, notes }) => {
    return axios.post(`${getApiUrl()}/experience-bookings/admin-create`, { eventId, targetUserId, tickets, notes }, config);
}

const fetchUsers = () => {
    return axios.get(`${getApiUrl()}/users`, config);
}

const verifySumupExperienceBooking = (bookingId) => {
    return axios.post(`${getApiUrl()}/experience-bookings/verify-payment`, { bookingId }, config);
}

const verifySumupBulkExperienceBookings = (checkoutId) => {
    return axios.post(`${getApiUrl()}/experience-bookings/verify-bulk-payment`, { checkoutId }, config);
}

const verifyWorldpayExperienceBooking = (bookingId, transactionId) => {
    return axios.post(`${getApiUrl()}/experience-bookings/verify-worldpay`, { bookingId, transactionId }, config);
}

const verifyWorldpayBulkExperienceBookings = (paymentId, transactionId) => {
    return axios.post(`${getApiUrl()}/experience-bookings/verify-worldpay-bulk`, { paymentId, transactionId }, config);
}

const recheckExperienceBookingPayment = (bookingId) => {
    return axios.post(`${getApiUrl()}/experience-bookings/${bookingId}/recheck-payment`, {}, config);
}

const joinWaitlist = (payload) => {
    return axios.post(`${getApiUrl()}/waitlist`, payload, config);
}

const leaveWaitlist = (payload) => {
    return axios.delete(`${getApiUrl()}/waitlist`, {
        ...config,
        data: payload
    });
}

const verifySumupBundlePurchase = (purchaseId) => {
    return axios.post(`${getApiUrl()}/bundles/purchase/verify-payment`, { purchaseId }, config);
}

const forgotPassword = async (email, recaptchaToken) => {
    return axios.put(`${getApiUrl()}/users/request-password-reset`, {
        Domain: getDomainId(),
        email,
        recaptchaToken
    });
}

const changePassword = async (email, oldPassword, newPassword) => {
    return axios.put(`${getApiUrl()}/users/change-password`, {
        Domain: getDomainId(),
        email,
        oldPassword,
        newPassword
    });
}

const resetPassword = async (email, newPassword, token) => {
    return axios.put(`${getApiUrl()}/users/change-password`, {
        Domain: getDomainId(),
        email,
        newPassword,
        token
    })
}

export default {
    fetchExperiences,
    fetchExperiencesPage,
    fetchExperienceById,
    createExperience,
    updateExperience,
    uploadImage,
    updateExperienceImage,
    deleteExperience,
    fetchEventsByExperienceId,
    createEvents,
    fetchAllEvents,
    fetchEventsPage,
    fetchEventById,
    updateSiteSettings,
    fetchDomainAdmin,
    testRemoteLockConnection,
    fetchEmailNotificationSettings,
    updateEmailNotificationSettings,
    createExperienceBooking,
    createBulkExperienceBookings,
    fetchAllExperienceBookings,
    fetchExperienceBookingsPage,
    exportExperienceBookings,
    fetchStuckExperienceBookingPayments,
    importExperienceBookings,
    fetchExperienceBooking,
    fetchExperienceBookingsByEventId,
    cancelExperienceBooking,
    adminCreateExperienceBooking,
    fetchUsers,
    verifySumupExperienceBooking,
    verifySumupBulkExperienceBookings,
    verifyWorldpayExperienceBooking,
    verifyWorldpayBulkExperienceBookings,
    recheckExperienceBookingPayment,
    joinWaitlist,
    leaveWaitlist,
    verifySumupBundlePurchase,
    checkDiscountCode,
    fetchBundlesForExperience,
    createBundlePurchase,
    createBundle,
    updateBundle,
    deleteBundle,
    fetchBundleById,
    deleteEvent,
    forgotPassword,
    changePassword,
    resetPassword,
    updateEvent
}
